import React, { useState } from 'react';

import { FormActions, FormBody, TFormValue } from '@dashboard/components/form-fields/ContactsGroupDialogForm';
import { useUpdateContactsGroupMutation } from '@dashboard/generated/wp/platform';
import { EditOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { alertError, alertSuccess } from '@wp-react/notifications';

import useCurrentContactsGroup from '../useCurrentContactsGroup';

export default function EditContactsGroupDialog() {
  const [open, setOpen] = useState(false);
  const [update, { loading }] = useUpdateContactsGroupMutation();
  const { data } = useCurrentContactsGroup();

  const onClose = () => setOpen(false);

  const model = data?.ContactsGroup;
  if (!model) {
    return null;
  }

  const onSubmit = async (variables: TFormValue) => {
    try {
      await update({ variables: { id: model.id, ...variables } });
      alertSuccess('Unsubscribe group updated');
      onClose();
    } catch (e) {
      alertError('Failed to edit unsubscribe group');
    }
  };

  const initialValues: TFormValue = {
    name: model.name,
    key: model.key ?? null,
    unsubscribeLinkTemplate: model.unsubscribeLinkTemplate,
    unsubscribePageTitleTemplate: model.unsubscribePageTitleTemplate,
    unsubscribePageSubtitleTemplate: model.unsubscribePageSubtitleTemplate,
    unsubscribePageEmailInputLabelTemplate: model.unsubscribePageEmailInputLabelTemplate,
    unsubscribePageSubmitButtonLabelTemplate: model.unsubscribePageSubmitButtonLabelTemplate,
    unsubscribePageConfirmationMessageTemplate: model.unsubscribePageConfirmationMessageTemplate,
    unsubscribePageInvalidEmailAddressMessageTemplate: model.unsubscribePageInvalidEmailAddressMessageTemplate,
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        startIcon={<EditOutlined />}
        onClick={() => setOpen(true)}
      >
        Edit
      </Button>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Edit unsubscribe group</DialogTitle>
        <DialogContent>
          <FormBody initialValues={initialValues} onSubmit={onSubmit} />
        </DialogContent>
        <FormActions version="EDIT" loading={loading} onClose={onClose} />
      </Dialog>
    </>
  );
}
